import React, { useCallback, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Paper from '@mui/material/Paper'
import EditIcon from '@mui/icons-material/Edit'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import DeleteForeverIcon from '@mui/icons-material/DeleteForever'
import { styled } from '@mui/material/styles'
import { roleListId, roleType } from '../../config/roleList'
import { DELETE_CONFIRM } from '../../constants/form'
import BasicModal from '../modal/BasicModal'
import Edit from './Edit'
import { checkUserRole } from '../../common/checkUserRole'
import { deleteItemStyle } from '../../store/actions/itemStyleAction'

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}))

const ItemStyleList = ({ itemStyle }) => {
    const dispatch = useDispatch()
    const { userInfo } = useSelector((state) => state.auth)
    const { roleList } = useSelector((state) => state.user)
    const [editOpen, setEditOpen] = useState(false)
    const handleDelete = useCallback(
        (id) => {
            if (window.confirm(DELETE_CONFIRM)) {
                dispatch(deleteItemStyle(id))
            }
        },
        [dispatch]
    )
    return (
        <>
            <BasicModal open={editOpen} setOpen={setEditOpen}>
                <Edit id={itemStyle.id} setOpen={setEditOpen} />
            </BasicModal>
            <Item>
                <div
                    style={{
                        textAlign: 'left',
                        marginTop: '10px',
                        fontSize: '12px',
                        color: 'grey',
                    }}
                >
                    <span>{itemStyle?.id}</span>

                    <ContentCopyIcon
                        onClick={() => {
                            if (itemStyle?.id) {
                                navigator.clipboard
                                    .writeText(itemStyle.id)
                                    .then(() => {
                                        alert(`${itemStyle.id} Copied`)
                                    })
                                    .catch((err) => {
                                        console.error('Failed to copy: ', err)
                                    })
                            }
                        }}
                        style={{
                            marginLeft: '20px',
                            cursor: 'pointer',
                            fontSize: '14px',
                        }}
                    />
                </div>
                <div
                    style={{
                        display: 'flex',

                        alignItems: 'center',
                    }}
                >
                    <span style={{ marginRight: '20px' }}>
                        {itemStyle?.name}
                    </span>
                    <EditIcon
                        onClick={() =>
                            checkUserRole(
                                userInfo,
                                roleList,
                                roleListId.ITEM,
                                roleType.EDIT
                            )
                                ? setEditOpen(true)
                                : alert('Not Permit User')
                        }
                        style={{
                            marginRight: '20px',
                            cursor: 'pointer',
                            fontSize: '15px',
                        }}
                    />
                    <DeleteForeverIcon
                        onClick={() =>
                            checkUserRole(
                                userInfo,
                                roleList,
                                roleListId.ITEM,
                                roleType.DELETE
                            )
                                ? handleDelete(itemStyle.id)
                                : alert('Not Permit User')
                        }
                        style={{
                            color: 'red',
                            cursor: 'pointer',
                            fontSize: '15px',
                        }}
                    />
                </div>
                <div
                    style={{
                        textAlign: 'left',
                        marginTop: '10px',
                        fontSize: '10px',
                        color: 'grey',
                    }}
                >
                    {itemStyle?.description}
                </div>
            </Item>
        </>
    )
}

export default ItemStyleList
